function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_-_Cross-2",
  d: "M10.52,13.393Q8.669,11.629,6.881,9.835q-1.789,1.8-3.644,3.558C1.49,15.056-1.18,12.425.572,10.761q1.883-1.793,3.7-3.617-1.8-1.906-3.536-3.9C-.841,1.44,1.816-1.2,3.4.615Q5.106,2.58,6.877,4.454q1.772-1.879,3.48-3.84c1.583-1.824,4.235.82,2.665,2.632q-1.735,2-3.536,3.9,1.816,1.828,3.7,3.612c1.354,1.291.056,3.163-1.41,3.163A1.8,1.8,0,0,1,10.52,13.393Z",
  fill: "#f23f37"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Cross",
    width: 13.755,
    height: 13.924,
    viewBox: "0 0 13.755 13.924",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.bb5e5a9e.svg";
export { ForwardRef as ReactComponent };